<template>
  <div v-bind:class="{ paddingContent: isSidebarShow, nonPaddingContent: !isSidebarShow }">
    <div class="container">
      <div class="breadCrumbsContainer" style="display: flex;">
        お知らせ　
        <div class="headerBtn" v-if="role == 'admin'" @click="add()">新規登録</div>
      </div>

      <div class="row">
        <p class="inputTitle condition">カテゴリー</p>
        <multiselect
          v-model="categoryCondition"
          :options="categoryOptions"
          :close-on-select="false"
          :multiple="true"
          :taggable="true"　
          placeholder="検索したいカテゴリーを選択"
          selectLabel="選択"
          deselectLabel="解除"
          selectedLabel="選択済"
          style="margin: auto"
        >
        <span slot="noOptions"></span>
        </multiselect>
        <!-- 選択されたタグの情報確認用 -->
        <!-- <pre class="language-json"><code>{{ siteCondition  }}</code></pre> -->
      </div>

      <div class="searchBtn" @click="search()">検索</div>
      <!-- ローディング -->
      <div v-if="getLodingFlg || deleteLodingFlg">
        <vue-loading
          type="cylon"
          color="#1b7e47"
          :size="{ width: '150px', height: '150px' }"
        >
        </vue-loading>
        <div style="padding: 0px 0px 30px 0px;">Now loading...</div>
      </div>
      <!-- 取得エラー表示 -->
      <div v-if="getErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errSpan" style="font-size:x-large;">
            {{errorMessage}}
          </div>
        </div>
      </div>
      <!-- 削除エラー表示 -->
      <div v-if="deleteErrorFlg" style="padding: 0px 0px 30px 0px; margin: auto;">
        <div　class="errMsg">
          <div class="errDiv">
            データの削除中に問題が発生しました。
          </div>
        </div>
      </div>
      <!-- 現在表示件数 / 検索結果最大件数 -->
      <div style="text-align:right"" v-if="!getLodingFlg && !getErrorFlg">
        <div v-if="limit * currentPage <= conditionRow.length">
          {{(limit * currentPage) - (limit - 1)}} - {{limit * currentPage}} / {{conditionRow.length}} 件
        </div>
        <div v-else>
          {{(limit * currentPage) - (limit - 1)}} - {{conditionRow.length}} / {{conditionRow.length}} 件
        </div>
      </div>
      <vue-good-table
        :columns='columns'
        :rows='conditionRow'
        :pagination-options="{
          enabled: true,
          perPageDropdownEnabled: false,
          mode: 'pages',
          perPage: 100,
          position: 'top',
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: '次へ',
          prevLabel: '前へ',
          rowsPerPageLabel: '表示する行数',
          ofLabel: '/',
          pageLabel: 'ページ',
          allLabel: 'All',
        }"
        :group-options="{
          enabled: false
        }"
        @on-page-change="onPageChange"
        @on-row-click="openDetailModal"
        v-if="!getLodingFlg && !getErrorFlg"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'operation'" style="display: flex;">
            <div class="edit" @click.stop="edit(props.formattedRow)">編集</div>
            <div class="remove" @click.stop="openDeleteModal(props.formattedRow)">削除</div>
          </span>
          <!-- 本文をリンクにして表示内容を短縮する -->
          <span v-if="props.column.field === 'text'" style="display: flex;">
            <div class="customText">{{props.formattedRow[props.column.field]}}</div>
          </span>
          <span v-else>{{props.formattedRow[props.column.field]}}</span>
        </template>
        <div slot="emptystate">データがありません</div>
      </vue-good-table>
      <button v-if="!deleteErrorFlg" type="button" class="csvBtn" @click="callOutputCsv()"
        :disabled="!csvDlFlg && conditionRow.length > csvLimit"
        v-bind:class="{
          disabled: !csvDlFlg && conditionRow.length > csvLimit,
          active: csvDlFlg && conditionRow.length <= csvLimit
        }"
      >
        表示中のデータをCSV形式でダウンロード
      </button>
      <div style="text-align:right">
        ※CSVダウンロード件数は最大{{csvLimit}}件になります。<br>
        　件数を超えている場合は検索条件にて絞り込みを行ってください。
      </div>
    </div>

    <!-- 詳細モーダル画面 -->
    <Modal size="notification" @close="closeModal(0)" v-if="detailModal">
      <p class="modalTitle">お知らせ詳細</p>
      <Detail mode='detail' :id=selectRow.id style="padding-left: 30px;" />
      <button @click="closeModal(0)" class="branchChange">閉じる</button>
    </Modal>

    <!-- 削除モーダル画面 -->
    <Modal size="delete" @close="closeModal(1)" v-if="deleteModal">
      <p class="modalTitle">削除しますか？</p>
      <div style="text-align:left; margin: 0px 30px 0px 30px; font-weight: bold;">
        <p>
          本当におしらせ情報を削除してよろしいですか？<br>
          一度削除したデータは復旧出来ませんので、ご了承下さい。
        </p>
      </div>
      <button @click.once="deleteExecution(selectRow.id)" class="modalYes">削除する</button>
      <button @click="closeModal(1)" class="modalNo" style="margin: 50px 0px 0px 30px;">キャンセル</button>
    </Modal>
  </div>
</template>

<script lang='ts'>
import { Component, Vue } from 'vue-property-decorator';
import '../style/vue-good-table.scss';
import { VueGoodTable } from 'vue-good-table';
import moment from 'moment';
import Modal from './BaseModal.vue';
import Detail from './NotificationEdit.vue';
import ApiClient from '../services/ApiClient';
import common from '../services/common';
import { VueLoading } from 'vue-loading-template';

// when使用のための処理 ------ start
type ChainedWhen<T, R> = {
  on: <A>(pred: (v: T) => boolean, fn: () => A) => ChainedWhen<T, R | A>;
  otherwise: <A>(fn: () => A) => R | A;
};

const match = <T, R>(val: any): ChainedWhen<T, R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) => match<T,  R | A>(val),
  otherwise: <A>(fn: () => A): A | R => val,
});

const chain = <T,  R>(val: T): ChainedWhen<T,  R> => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match(fn()) : chain<T,  A | R>(val),
  otherwise: <A>(fn: () => A) => fn(),
});

const when = <T>(val: T) => ({
  on: <A>(pred: (v: T) => boolean, fn: () => A) =>
    pred(val) ? match<T,  A>(fn()) : chain<T,  A>(val),
});
// when使用のための処理 ------ end

export default {
  title: 'お知らせ一覧',
  name: 'branch',
  components: {
    VueGoodTable,
    Modal,
    Detail,
    VueLoading,
  },
  data() {
    return {
      detailModal: false,
      deleteModal: false,
      categoryOptions: this.setCategoryDropDown(),
      categoryCondition: [],
      notificationCategories: [],
      // ローディング
      getLodingFlg: false,    // データ取得時ローディング用フラグ
      getErrorFlg: false,     // データ取得時エラーフラグ
      deleteLodingFlg: false, // データ削除時ローディングフラグ
      deleteErrorFlg: false,// データ削除時エラーフラグ
      csvDlFlg: false,
      errorMessage: '',
      columns: [
        {
          label: '内部ID',
          field: 'id',
          sortable: true,
          hidden: true,
        },
        {
          label: 'カテゴリーId',
          field: 'notificationCategoryId',
          sortable: true,
          hidden: true,
        },
        {
          label: 'カテゴリー',
          field: 'notificationCategoryName',
          sortable: true,
          // hidden: this.roleCheck(2),
          width: '110px',
        },
        {
          label: 'タイトル',
          field: 'title',
          sortable: true,
          width: '200px',
        },
        {
          label: '本文',
          field: 'body',
          sortable: false,
          tdClass: 'customText',
          formatFn: this.textShortening,
          width: '335px',
        },
        {
          label: '有効期限',
          field: 'expiredAt',
          sortable: true,
          hidden: this.roleCheck(),
          width: '140px',
          formatFn: this.callDateFormat,
        },
        {
          label: '日付',
          field: 'createdAt',
          sortable: true,
          width: '140px',
          formatFn: this.callDateFormat,
        },
        {
          label: '最終更新日時',
          field: 'updatedAt',
          sortable: true,
          hidden: true,
          formatFn: this.callDateFormat,
        },
        {
          label: '',
          field: 'operation',
          sortable: false,
          hidden: this.roleCheck(2),
          width: '150px',
        },
      ],
      rows: [],
      conditionRow: [],
      // 選択行のデータを詰める
      selectRow: {},
      displayingModal: 0,
      // 検索上限
      limit: 100,
      // 検索内容最大件数
      maxCount: 0,
      // 現在ページ
      currentPage: 1,
      // 現在ページ
      inputPage: 1,
      // 最大ページ数
      maxPage: 1,
      // CSV取得上限
      csvLimit: 10000,
    };
  },
  async mounted() {
    try {
      // ローディング表示
      this.getLodingFlg = true;
      // お知らせ一覧取得API呼出
      this.rows = await this.callGetNotificationList();
      // 初期テーブルデータをセット
      this.conditionRow = this.rows;
      // お知らせカテゴリ取得API呼出
      this.notificationCategories = await this.callGetNotificationCategories();
      // URL検索条件確認
      this.categoryCondition = common.getUrlParam('category', 0);
      // 検索処理呼出
      this.search();
    } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
    } finally {
      this.getLodingFlg = false;
    }
  },
  computed: {
    role() {
      return this.$store.getters.session.role;
    },
    isSidebarShow() {
      return this.$store.getters.session.isSidebarShow;
    },
  },
  watch: {
    role() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
    isSidebarShow() {
      this.$nextTick(() => {
        // 必要であれば処理を書く 現状必要なロジックはない
      });
    },
  },
  methods: {
    // お知らせ一覧取得API呼び出し
    async callGetNotificationList() {
      try {
        const restResourceService = new ApiClient();
        const resultRows = await restResourceService.getNotificationList();
        // エポックミリ秒をYYYY-MM-DDに変換
        resultRows.forEach((notification, index) => {
          resultRows[index].createdAt = common.dateFormatHyphen(notification.createdAt),
          resultRows[index].expiredAt = common.dateFormatHyphen(notification.expiredAt);
        });
        return resultRows;
      } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
      throw error;
      }
    },
    // 日時値を年月日（YYYY年MM月DD日）に変換
    callDateFormat(value) {
      return common.dateFormat(value);
    },
    // お知らせカテゴリ取得API呼び出し
    async callGetNotificationCategories() {
      try {
        const restResourceService = new ApiClient();
        return await restResourceService.getNotificationCategories();
      } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
      throw error;
      }
    },
    // カテゴリIDからカテゴリ名を返却  Nameが返却されるようになったため、不要か
    categoryConversion(value) {
      const result = this.notificationCategories.find((v) => v.id === value);
      if (result) {
        return result.name;
      }
    },
    // お知らせカテゴリーセット
    setCategoryDropDown() {
      const TAG_CODE = 'TAGCODE';

      return [
        'お知らせ',
        '重要',
        'メンテナンス',
        '障害情報',
      ];
    },
    // 権限によって表示列を非表示にする処理
    roleCheck() {
      // 運営管理者の場合は全て表示
      // computedの変数はこの時点では参照できないため、gettersで直接参照する
      if (this.$store.getters.session.role === 'admin') {
        return false;
      // 運営管理者以外には非表示にする
      } else {
        return true;
      }
    },
    // 検索ボタン押下時
    search() {
      this.setCondition(this.rows);
      // 検索条件をURLに詰める
      common.setUrlParam('category', this.categoryCondition, 0);
      this.csvDlFlg  = (this.conditionRow.length > 0) ? true : false;
    },
    // 一覧上部の検索条件を一覧へ反映
    setCondition(rows) {
      if (this.categoryCondition.length === 0) {
        // 検索条件がない場合、初期データを書き戻す
        this.conditionRow = rows;
        return;
      }
      let newRows = [];
      let tempRows = rows;
      this.conditionRow = [];

      // 検索条件：カテゴリーを検索
      if (this.categoryCondition.length !== 0) {
        newRows = tempRows.filter((v) =>
          this.categoryCondition.includes(v.notificationCategoryName),
        );
        if (newRows.length !== 0) {
          // Array.prototype.push.apply(this.conditionRow, newRows);
          this.conditionRow = newRows;
          tempRows = this.conditionRow;
        }
      }
    },
    // お知らせ新規登録画面へ遷移
    add() {
      this.$router.push('/notifications/add');
    },
    // お知らせ編集画面へ遷移
    edit(params) {
      this.selectRow = params;
      this.$router.push({
        name: 'NotificationEdit',
        params: {
          id: this.selectRow.id,
          mode: 'edit',
        },
      });
    },
    // 削除実行
    async deleteExecution(value) {
      try {
        this.deleteErrorFlg = false;
        this.deleteLodingFlg = true;
        const restResourceService = new ApiClient();
        // お知らせ削除API呼び出し
        await restResourceService.deleteNotification(value);
        // お知らせ一覧再取得
        const resGetList = await this.callGetNotificationList();
        this.rows = resGetList;
        this.conditionRow = this.rows;
      } catch (error) {
      this.errorMessage = error.message;
      this.getErrorFlg = true;
      this.deleteErrorFlg = true;
      } finally {
        this.closeModal(1);
        this.deleteLodingFlg = false;
      }
    },
    // 詳細モーダルを開く
    openDetailModal(params) {
      this.displayingModal = 0;
      window.history.pushState(null, null, null);
      window.addEventListener('popstate', this.modalBack);
      this.selectRow = params.row;
      this.detailModal = true;
    },
    // 削除モーダルを開く
    openDeleteModal(params) {
      this.displayingModal = 1;
      window.history.pushState(null, null, null);
      window.addEventListener('popstate', this.modalBack);
      this.selectRow = params;
      this.deleteModal = true;
    },
    // モーダルを閉じる
    closeModal(num) {
      window.removeEventListener('popstate', this.modalBack);
      when(num)
        .on((v) => v === 0, () => this.detailModal = false)   // 詳細
        .on((v) => v === 1, () => this.deleteModal = false);  // 削除
    },
    // モーダル表示中ブラウザバック処理
    modalBack() {
      this.closeModal(this.displayingModal);
    },
    // CSV出力用共通関数呼出
    async callOutputCsv() {
      const columns = this.columns;
      // 参照元更新回避
      const rows = JSON.parse(JSON.stringify(this.conditionRow));
      let rowCount = 0;
      for(const row of rows) {
        if (row.createdAt) {
          rows[rowCount].createdAt = common.dateFormat(row.createdAt);
        }
        if (row.expiredAt) {
          rows[rowCount].expiredAt = common.dateFormat(row.expiredAt);
        }
        // 本文中にカンマ(,)が含まれている場合はCSV出力時の共有処理で行っているため、スキップ
        if(rows[rowCount].body.includes(',')) {
          rowCount ++;
          continue;
        }
        rows[rowCount].body = '"' + row.body + '"';
        rowCount ++;
      }
      // ファイル名用の現在日時
      const currentDate = new Date().getTime();
      const date = await common.getToday(currentDate);
      const fileName = 'お知らせ一覧'+date;
      common.outputCsv(columns, rows, fileName);
    },
    // 本文短縮フォーマット
    textShortening(value) {
      if(value.length < 70) {
        return value;
      }
      let str = value.substr(0, 70);
      str += '...';
      return str;
    },
    // 現在ページ更新
    onPageChange(params) {
      this.currentPage = params.currentPage;
      common.scrollTop();
    },
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
@import "../style/variables.scss";
.customText {
    width: 500px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; /* flexがあると利かなかったのでaタグにクラスを置くことに */
    -webkit-text-overflow: ellipsis;
    -o-text-overflow: ellipsis;
}
.modalTitle {
  margin: 30px auto;
  font-weight: bold;
  font-size: $font-medium;
  color: $font_color;
}
.modalYes {
  background-color: $button-primary;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  margin-bottom: 20px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
.modalNo {
  background-color: $button-danger;
  color: $active_font_color;
  font-size: $font-medium;
  width: 200px;
  height: 50px;
  padding: 10px, 10px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  outline: none;
  appearance: none;
  font-weight: bold;
}
</style>
